<template>
  <div>
    <el-dialog title="合磅" :visible.sync="heBangVisible" :close-on-click-modal="false" width="85%" center
      :before-close="closeadd">
      <div class="topForm">
        <div>
          <div style="margin:20px 30px 20px 10px;">称重类型：</div>
          <div style="width:100px;">
            <el-radio-group v-model="weightType">
              <el-radio :label="1" style="margin:10px 30px 20px 20px;">合磅</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="margin:0 20px 20px 50px;text-align: center;">
          <div style="margin:20px 30px 20px 0;font-weight: 700;">本次称重</div>
          <div class="weigthBox">
            <span>{{ poundWeight }}</span>
          </div>
          <div style="margin-top:10px;">
            <div>如有故障，请<span style="color:blue;">手动输入</span></div>
          </div>
          <div style="margin-top:10px;">
            <el-input v-model="wieghtInput" placeholder="请输入重量" size="mini" v-number-input.float="4" maxlength="50"
              style="width:130px;"></el-input> 吨
          </div>
        </div>
        <div style="margin:0 20px 20px 50px;text-align: center;">
          <div style="margin:20px 30px 20px 0;font-weight: 700;">总净重（吨）</div>
          <div class="weigthBox">
            <span>{{ allJZ }}</span>
          </div>
        </div>
        <!-- <div style="margin:0 30px 20px 50px;text-align: center;">
        <div style="margin:30px 30px 20px 0;font-weight: 700;">净重</div>
        <div class="weigthBoxB">
          <span>13.999</span>
        </div>
      </div> -->
      </div>
      <div class="bottomTable">
        <div class="detailsTitle">
          <h4>货物信息</h4>
          <el-button style="position:absolute;left:110px;" type="primary" @click="refreshClick">刷新</el-button>
          <el-button style="position:absolute;left:170px;" type="primary" @click="clearWeightingWeight">清空毛重</el-button>
          <div style="position:absolute;left:280px;margin-top:5px;">{{ GBoutstockPlateNumber }}</div>
        </div>
        <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableList"
          :data="tableList" style="width: 100%" highlight-current-row @row-click="dianjixuanzhong"
          :row-class-name="tableRowClassName" class="elTab">
          <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
          <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" align="center" width="130"></el-table-column>
          <el-table-column prop="model" label="材质" align="center" width="130"></el-table-column>
          <el-table-column prop="number" label="件数" align="center"></el-table-column>
          <el-table-column prop="grossWeight" label="毛重(吨)" align="center"></el-table-column>
          <el-table-column prop="grossWeightTime" label="毛重时间" align="center" width="180"
            :formatter="dateTimeFormat"></el-table-column>
          <el-table-column prop="tareWeight" label="皮重(吨)" align="center"></el-table-column>
          <el-table-column prop="tareWeightTime" label="皮重时间" align="center" width="180"
            :formatter="dateTimeFormat"></el-table-column>
          <el-table-column prop="weightingWeight" label="净重(吨)" align="center"></el-table-column>
          <el-table-column prop="estimatedSingletonWeight" label="预报实入件重(吨)" align="center" width="130"></el-table-column>
          <el-table-column prop="warehouseName" label="仓位" align="center"></el-table-column>
          <el-table-column prop="vehicleNumber" label="船号" align="center"></el-table-column>
          <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="300"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" style="width: 220px; margin: 15px auto">
        <el-button @click="closeadd">取 消</el-button>
        <el-button type="primary" :loading="Loading" @click="addDialog" :disabled='addDisabled'>保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  calculateOutStockWeight, // 刷新调接口
  mergeOutStockWeight, // 合磅刷新接口
  getPoundWeight,
  clearOutStockWeightInfo // 清空毛重
} from '@/api/wms-access'
import {
  getEmptyWeightInfoListForOutstockId,
  updateEmptyWeightInfoList// 合磅保存
} from '@/api/wms-stock'
import { dateTimeFormat } from '@/utils/util.js'
import DonMessage from '@/utils/message'
export default {
  name: 'xieCheDialog',
  data() {
    return {
      dateTimeFormat: dateTimeFormat,
      tableList: [],
      Loading: false,
      weightType: 1,
      wieghtInput: '',
      xuanzhongArr: null,
      addDisabled: true,
      poundWeight: 0,
      allJZ: 0,
      _inter: null,
      allWeight: ''
    }
  },
  props: {
    heBangVisible: {
      type: Boolean,
      default: false
    },
    outstockId: {
      type: Number
    },
    GBoutstockPlateNumber: {
      type: String
    }
  },
  watch: {
  },
  created() {
    this.getInWeightInfoList()
    this.interval()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
      }
    }
  },
  methods: {
    interval() {
      this._inter = setInterval(() => {
        this.getPoundWeight()
      }, 1000)
    },
    getPoundWeight() {
      getPoundWeight()
        .then(res => {
          this.poundWeight = res
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    getInWeightInfoList() {
      getEmptyWeightInfoListForOutstockId({
        outstockId: this.outstockId
      })
        .then(res => {
          let num = []
          if (res.length != 0) {
            this.tableList = res
            res.forEach(item => {
              if (!item.weightingWeight) {
                item.weightingWeight = 0
              }
            });

            this.allJZ = Math.round(this.tableList.reduce((cur, pre) => {
              return cur + pre.weightingWeight / 1
            }, 0) * 100) / 100
          }

        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    closeDialogFile() {
      this.Loading = false
    },
    closeadd() {
      this.$emit('update:heBangVisible', false)
      clearInterval(this._inter)
    },
    addDialog() {
      let flagB = this.tableList.some(item => item.checkFlag == 1)
      // 任务8420 修改提示信息
      if (flagB) {
        this.$confirm('存在过磅平均件重超过预报实入件重的千分之三（红色部分）！是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.shipStockWeight(this.tableList)
        }).catch(() => {
        })
      } else {
        this.shipStockWeight(this.tableList)
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
      if (row.checkFlag == '1') {
        return 'red'
      }
      return ''
    },
    dianjixuanzhong(row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    shipStockWeight(params) {
      updateEmptyWeightInfoList(params).then(res => {
        DonMessage.success('保存成功')
        this.closeadd()
        this.$parent.chaxun()
      })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 点击刷新
    refreshClick() {
      // 无毛重调取接口获取毛重
      if (this.wieghtInput == '' && this.poundWeight == '0') {
        DonMessage.error('请填写重量')
      } else {
        if (this.wieghtInput != '' && this.poundWeight != '0') {
          this.allWeight = this.wieghtInput
        } else if (this.wieghtInput != '' && this.poundWeight == '0') {
          this.allWeight = this.wieghtInput
        } else if (this.poundWeight != '0') {
          this.allWeight = this.poundWeight
        }
        let flagA = true
        flagA = this.tableList.some(im => !im.tareWeight)
        console.log(flagA, 'flagA')
        if (flagA) {
          calculateOutStockWeight({
            // index: this.xuanzhongArr.index, // 索引,
            weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
            weightFlag: '皮重', // 毛重或皮重的标识，
            operator: localStorage.getItem('userName'), // 操作人，
            list: this.tableList // 过磅页面回显的list数据
          }).then(res => {
            this.tableList = res.list
            this.addDisabled = false
            this.wieghtInput = ''
            if (res.list.length != 0) {
              res.list.forEach(item => {
                if (!item.weightingWeight) {
                  item.weightingWeight = 0
                }
              });
              this.allJZ = Math.round(res.list.reduce((cur, pre) => {
                return cur + pre.weightingWeight / 1
              }, 0) * 100) / 100
            }
            // checkFlag：是否超过千分之三 0：没有，1：有
            if (res.checkFlag == '1') {
            }
          })
            .catch(err => {
              DonMessage.error(err.message)
            })
        } else {
          mergeOutStockWeight({
            grossWeight: this.allWeight,
            operator: localStorage.getItem('userName'), // 操作人，
            list: this.tableList // 过磅页面回显的list数据
          }).then(res => {
            this.tableList = res.list
            this.addDisabled = false
            this.wieghtInput = ''
            if (res.list.length != 0) {
              res.list.forEach(item => {
                if (!item.weightingWeight) {
                  item.weightingWeight = 0
                }

              });
              this.allJZ = Math.round(res.list.reduce((cur, pre) => {
                return cur + pre.weightingWeight / 1
              }, 0) * 100) / 100

            }
            // checkFlag：是否超过千分之三 0：没有，1：有
            // if (res.checkFlag == '1') {
            //   this.$confirm('平均件重超过库存件重，是否继续', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            //   }).then(() => {
            //     this.shipStockWeight(this.tableList)
            //   }).catch(() => {
            //   })
            // }
          })
            .catch(err => {
              DonMessage.error(err.message)
            })
        }
      }
    },
    // 清空毛重
    clearWeightingWeight() {
      let grossWeightFlag = this.tableList.every(item => !!item.grossWeight)
      console.log(grossWeightFlag, 'grossWeightFlag')
      if (grossWeightFlag) {
        this.$confirm('是否清空全部毛重，清空后不可恢复', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          clearOutStockWeightInfo({
            outStockId: this.outstockId
          }).then(res => {
            this.getInWeightInfoList()
            this.addDisabled = false
          })
            .catch(err => {
              DonMessage.error(err.message)
            })
        }).catch(() => {
        })
      } else {
        DonMessage.error('没有毛重数据')
      }
    }
  },
  mounted() {
  }

}
</script>

<style lang="less" scoped>
.topForm {
  display: flex;
}

.weigthBox {
  width: 160px;
  height: 120px;
  border: dashed 3px green;
  text-align: center;
  line-height: 120px;
  font-size: 24px;
  font-weight: 700;
  color: red;
  background-color: #f6f6f6;
}

.weigthBoxB {
  width: 160px;
  height: 120px;
  border: dotted 3px #ccc;
  text-align: center;
  line-height: 120px;
  font-size: 24px;
  font-weight: 700;
  background-color: #f6f6f6;
}

/deep/.el-table .red {
  background: red;
  color: #fff;
}
</style>
